(() => {
  const bound = new Map();
  const init = (root = document) => {
    root.querySelectorAll('[data-cc-card-track]').forEach((track) => {
      if (bound.has(track)) return;
      const navigation = track.nextElementSibling;
      if (!navigation?.matches('[data-cc-card-navigation]')) return;
      const cards = [...track.children];
      if (cards.length < 2) return;
      const previous = navigation.querySelector('[data-cc-card-previous]');
      const next = navigation.querySelector('[data-cc-card-next]');
      const count = navigation.querySelector('[data-cc-card-count]');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const positions = () => {
        const left = track.getBoundingClientRect().left + track.clientLeft;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        return cards.map((card) => Math.max(0, Math.min(max,
          card.getBoundingClientRect().left - left + track.scrollLeft)));
      };
      const current = () => {
        const offsets = positions();
        return offsets.reduce((best, offset, index) =>
          Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? index : best, 0);
      };
      const update = () => {
        const index = current();
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
        const text = `${index + 1} / ${cards.length}`;
        if (count.textContent !== text) count.textContent = text;
      };
      const move = (direction) => {
        const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
        track.scrollTo({ left: positions()[index], behavior:
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      window.addEventListener('resize', update, options);
      navigation.querySelector('[data-cc-card-buttons]').hidden = false;
      bound.set(track, controller);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [track, controller] of bound) {
      if (event.target.contains(track)) {
        controller.abort();
        bound.delete(track);
      }
    }
  });
})();
